import { render, staticRenderFns } from "./addMaterialRequisitionForm.vue?vue&type=template&id=57596488&scoped=true&"
import script from "./addMaterialRequisitionForm.vue?vue&type=script&lang=js&"
export * from "./addMaterialRequisitionForm.vue?vue&type=script&lang=js&"
import style0 from "./addMaterialRequisitionForm.vue?vue&type=style&index=0&id=57596488&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57596488",
  null
  
)

export default component.exports